import { render, staticRenderFns } from "./ClubDesktopInfoModal.vue?vue&type=template&id=5a77e6e6&"
import script from "./ClubDesktopInfoModal.vue?vue&type=script&lang=js&"
export * from "./ClubDesktopInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a77e6e6')) {
      api.createRecord('5a77e6e6', component.options)
    } else {
      api.reload('5a77e6e6', component.options)
    }
    module.hot.accept("./ClubDesktopInfoModal.vue?vue&type=template&id=5a77e6e6&", function () {
      api.rerender('5a77e6e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/Club/components/dependencies/ClubDesktopInfoModal/ClubDesktopInfoModal.vue"
export default component.exports